import './BigModal.css'

function BigModal({ isOpen, title, children, footer, onClose }) {
    if (!isOpen) {
        return null
    }

    return (
        <div
            className="bigModalOverlay"
            onClick={onClose}
        >
            <div
                className="bigModalBox"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="bigModalHeader">
                    <h2>{title}</h2>

                    <button
                        type="button"
                        className="bigModalClose"
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>

                <div className="bigModalBody">
                    {children}
                </div>

                {footer && (
                    <div className="bigModalFooter">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    )
}

export default BigModal